import React from 'react';
import { BellOutlined } from '@ant-design/icons';
import { Badge } from 'antd';
import styles from '../style/Notifications.module.scss';
import { useNotificationStore } from '../../../../store/notificationStore';

export default function Notifications() {
  const notifications = useNotificationStore(state => state.notifications)
  const lastSeenAt = useNotificationStore(state => state.lastSeenAt)
  const markAllRead = useNotificationStore(state => state.markAllRead)

  const hasNew = notifications.some(n => n.time > lastSeenAt)

  function openNotifications() {
    markAllRead()
  }

  return (
    <Badge
      dot={hasNew}
      className={styles.cartBadge}
      offset={[-4, 10]}
    >
      <BellOutlined onClick={openNotifications} className={styles.cartIcon} />
    </Badge>
  )
}
